import { render, staticRenderFns } from "./fp-gift.vue?vue&type=template&id=61138ad3&"
import script from "./fp-gift.vue?vue&type=script&lang=js&"
export * from "./fp-gift.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61138ad3')) {
      api.createRecord('61138ad3', component.options)
    } else {
      api.reload('61138ad3', component.options)
    }
    module.hot.accept("./fp-gift.vue?vue&type=template&id=61138ad3&", function () {
      api.rerender('61138ad3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/fp-gift.vue"
export default component.exports